import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

// Quiet ghost-button dropdown grouping secondary admin actions (page
// navigation + modal triggers) that don't belong in the primary action row.
// Keeps the header to one extra element regardless of how many admin tools
// get added later. Closes on outside click and Escape.
//
// Item shapes: { label, to }  -> internal route via react-router <Link>
//              { label, href } -> external URL via plain <a> (new tab)
//              { label, onClick } -> action button
export function AdminToolsMenu({ items }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handlePointerDown = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
    };
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open]);

  return (
    <div ref={rootRef} style={{ position: "relative" }}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="menu"
        aria-expanded={open}
        style={{
          padding: "8px 14px",
          background: "transparent",
          color: "#626262",
          border: "1px solid #E2E2E2",
          borderRadius: 8,
          fontSize: 12,
          fontWeight: 600,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        Admin Tools
        <span style={{ fontSize: 9, transform: open ? "rotate(180deg)" : "none", transition: "transform 0.12s" }}>▾</span>
      </button>
      {open && (
        <div
          role="menu"
          style={{
            position: "absolute",
            top: "calc(100% + 6px)",
            left: 0,
            minWidth: 220,
            background: "#FFFFFF",
            border: "1px solid #E2E2E2",
            borderRadius: 10,
            boxShadow: "0 3px 15px rgba(0,0,0,0.08)",
            padding: 6,
            zIndex: 20,
          }}
        >
          {items.map((item) => {
            const itemStyle = {
              display: "block",
              width: "100%",
              boxSizing: "border-box",
              textAlign: "left",
              padding: "9px 10px",
              background: "none",
              border: "none",
              borderRadius: 7,
              color: "#151515",
              fontSize: 13,
              cursor: "pointer",
              textDecoration: "none",
            };
            const handleSelect = () => {
              setOpen(false);
              item.onClick?.();
            };
            if (item.to) {
              return (
                <Link key={item.label} to={item.to} role="menuitem" style={itemStyle} onClick={() => setOpen(false)}>
                  {item.label}
                </Link>
              );
            }
            if (item.href) {
              return (
                <a key={item.label} href={item.href} target="_blank" rel="noreferrer" role="menuitem" style={itemStyle} onClick={() => setOpen(false)}>
                  {item.label}
                </a>
              );
            }
            return (
              <button key={item.label} type="button" role="menuitem" style={itemStyle} onClick={handleSelect}>
                {item.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
